<div class="gnv-form-content">
    <app-dropdown
        [options]="recipientTypeOptions"
        [fieldPlaceholder]="'notifications.table.recipientsType' | translate"
        [valueFormControl]="requestFormGroup.controls.destinationType"
        (gnvValueChanges)="onDestinationTypeChanged()"
    ></app-dropdown>

        <app-dropdown
            [options]="(destinationOptions$ | async) || []"
            [isMultiSelect]="true"
            [fieldPlaceholder]="'notifications.table.recipients' | translate"
            [valueFormControl]="requestFormGroup.controls.destinationValues"
        ></app-dropdown>
</div>



